export const Observer = {
  events: {},
  emit(event: string, ...args: any[]) {
    const e = (this as any).events[event] as any[];
    if (!(e)) return;

    e.forEach((cb) => {
      cb(...args);
    });
  },
  on(event: string, cb: any, once?: boolean) {
    let e = (this as any).events[event];
    if (!(e && e instanceof Array)) {
      (this as any).events[event] = [];
      e = (this as any).events[event];
    }

    if (once && e.includes(cb)) return;

    e.push(cb);
  }
};

export const SERVER_ERROR = 'server_error';
